const radThreeRouter = [
  {
    path: '/stylelist',
    name: 'styleList',
    component: () => import('@/views/wxapp/rad/radThree/list'),
    meta: {
      title: '风格色彩评估'
    }
  },
  {
    path: '/shareindex',
    name: 'shareindex',
    component: () => import('@/views/wxapp/rad/radThree/share/shareindex'),
    meta: {
      title: '风格色彩评估'
    }
  },
  {
    path: '/invitation',
    name: 'invitation',
    component: () => import('@/views/wxapp/rad/radThree/share/invitation'),
    meta: {
      title: '风格色彩评估'
    }
  },
  {
    path: '/changeProblem',
    name: 'changeProblem',
    component: () => import('@/views/wxapp/rad/radThree/change/changeProblem'),
    meta: {
      title: '风格色彩评估'
    }
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/wxapp/rad/radThree/testComplete/test'),
    meta: {
      title: '风格色彩评估'
    }
  },
  {
    path: '/result',
    name: 'result',
    component: () => import('@/views/wxapp/rad/radThree/testComplete/result'),
    meta: {
      title: '风格色彩评估'
    }
  },
  {
    path: '/functionInfo',
    name: 'functionInfo',
    component: () => import('@/views/wxapp/rad/radThree/testComplete/functionInfo'),
    meta: {
      title: '风格色彩评估'
    }
  },
  {
    path: '/designer',
    name: 'designer',
    component: () => import('@/views/wxapp/rad/radThree/testComplete/designer'),
    meta: {
      title: '风格色彩评估'
    }
  },
  {
    path: '/map',
    name: 'map',
    component: () => import('@/views/wxapp/customer-manager/home/map'),
    meta: {
      title: '定位'
    }
  }
]
export default radThreeRouter
